import { useEffect } from "react";
import { Redirect } from "wouter";
import ClarityOneLayout from "@/components/clarity-one/ClarityOneLayout";
import { Link2Off } from "lucide-react";

/** Magic-link login is retired — redirect legacy /auth/verify URLs to OTP login. */
export default function ClarityOneAuthVerifyPage() {
  useEffect(() => {
    console.info("[Clarity One] Magic-link login is no longer supported; use OTP login.");
  }, []);

  return (
    <ClarityOneLayout showNav={false}>
      <div className="flex flex-col items-center justify-center py-20 text-center px-4 max-w-md mx-auto">
        <div className="h-14 w-14 rounded-full bg-[#FAFAF7] border border-[#E8E4DC] flex items-center justify-center mb-5">
          <Link2Off className="h-6 w-6 text-[#8B7355]" />
        </div>
        <p className="text-lg font-medium text-[#1A2744] mb-2">Login links are no longer used</p>
        <p className="text-sm text-[#8B7355] leading-relaxed mb-8">
          Clarity One now uses a WhatsApp verification code. Please sign in with your mobile number.
        </p>
        <Redirect to="/login" />
      </div>
    </ClarityOneLayout>
  );
}
